
import { City, CityPoint } from "@/models/City";
import { MAPMOD_TYPE, ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PoiMapModifiersTable from "../Tables/PoiMapModifiersTable.vue";
import PoiMapModifiersTriggerTable from "../Tables/PoiMapModifiersTriggerTable.vue";
import Map from "../../../Base/Map.vue";
import { MapOptions } from "@/models/Map";
import { cloneDeep, forIn, isEmpty, isEqual } from "lodash";
import DateHelper from "@/utils/DateHelper";

@Component({
  components: { PoiMapModifiersTable, PoiMapModifiersTriggerTable, Map },
})
class PoiMapModifiers extends Vue {
  @Prop({ default: null }) readonly mapPoi!: ManhuntMapPoi;
  @Prop({ default: null }) readonly cityData!: City;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  mapPoiClone = {} as ManhuntMapPoi;
  errorMessage = "";
  targetMapPoi = {} as ManhuntMapPoi | undefined;
  mod_type = "";

  created(): void {
    this.mapPoiClone = cloneDeep(this.mapPoi);
    this.mod_type = this.mapPoi.map_mods.type;
  }

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }
  get getLocationsArray(): CityPoint[] {
    const arr: CityPoint[] = [];
    forIn(this.getCityData.locations, (val: CityPoint) => {
      arr.push(val);
    });
    return arr;
  }

  get getMapPoiData(): ManhuntMapPoi[] {
    return this.$store.state.mapPoiStore.mapPoi;
  }

  get getTriggerBy(): string {
    if (this.mapPoi.map_mods.targetedBy !== undefined) {
      if (this.mapPoi.map_mods.targetedBy?.trigger !== undefined) {
        var targetedBy = "";
        forIn(
          this.mapPoi.map_mods.targetedBy?.trigger,
          (value: any, key: any) => {
            var result = this.getMapPoiData.find((x) => x.key == key);
            targetedBy += result?.title.en + ",";
          }
        );
        return targetedBy.substring(0, targetedBy.length - 1);
      }
    }
    return "None";
  }
  get getRunawayBy(): string {
    if (this.mapPoi.map_mods.targetedBy !== undefined) {
      if (this.mapPoi.map_mods.targetedBy?.runaway !== undefined) {
        var runawayTargetBy = "";
        forIn(
          this.mapPoi.map_mods.targetedBy?.runaway,
          (value: any, key: any) => {
            var result = this.getMapPoiData.find((x) => x.key == key);
            runawayTargetBy += result?.title.en + ",";
          }
        );
        return runawayTargetBy.substring(0, runawayTargetBy.length - 1);
      }
    }
    return "None";
  }

  get getCurrentMapLocation(): MapOptions {
    var val = this.getCityData.locations[this.mapPoi.loc.loc_uid];
    if (val !== undefined) {
      var locationMarker: MapOptions = {
        position: {
          lat: val.lat_long.latitude,
          lng: val.lat_long.longitude,
        },
        title: this.mapPoi.title.en,
        draggable: true,
        clickable: true,
        slug: val.slug,
        radius: this.mapPoi.loc.geo_rad_m,
        color: this.mapPoi.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
        zIndex: 1001,
        icon: DateHelper.getMapImage(this.mapPoi),
      };
      return locationMarker;
    } else {
      var locationMarker2: MapOptions = {
        position: {
          lat: this.mapPoi.loc.override_ll.latitude,
          lng: this.mapPoi.loc.override_ll.longitude,
        },
        title: this.mapPoi.title.en,
        draggable: true,
        clickable: true,
        slug: this.mapPoi.title.en,
        radius: this.mapPoi.loc.geo_rad_m,
        color: this.mapPoi.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
        zIndex: 1001,
        icon: DateHelper.getMapImage(this.mapPoi),
      };
      return locationMarker2;
    }
  }

  get getMapLocation(): MapOptions[] {
    var arr: MapOptions[] = [];
    try {
      this.getMapPoiData.forEach((val: ManhuntMapPoi) => {
        if (val.key !== this.mapPoi.key && val.title.en !== "START_ZONE") {
          var cityData = this.getLocationsArray.find(
            (x: CityPoint) => val.loc.loc_uid === x.slug
          );
          var locationMarker2: MapOptions = {
            position: {
              lat:
                cityData !== undefined && cityData.lat_long !== undefined
                  ? cityData!.lat_long.latitude
                  : val.loc.override_ll.latitude,
              lng:
                cityData !== undefined && cityData.lat_long !== undefined
                  ? cityData!.lat_long.longitude
                  : val.loc.override_ll.longitude,
            },
            title: val.title.en,
            draggable: false,
            clickable: true,
            slug: val.key,
            radius: val.loc.geo_rad_m,
            color: val.key === "START_ZONE" ? "#2499DB" : "#E06B6B",
            zIndex: 100,
            icon: this.getIconChoice(val),
            isRunaway: this.isRunaway(val),
          };

          arr.push(locationMarker2);
        }
      });
      arr.push(this.getCurrentMapLocation);
      return arr;
    } catch (error) {
      console.log(error);
      return arr;
    }
  }

  getIconChoice(val: ManhuntMapPoi): string {
    if (
      this.mapPoi.map_mods.active &&
      (this.mapPoi.map_mods.type === "runaway" ||
        this.mapPoi.map_mods.type === "trigger")
    ) {
      if (this.mapPoi.map_mods.type === "runaway") {
        if (
          this.mapPoi.map_mods.runaway !== undefined &&
          this.mapPoi.map_mods.runaway?.targets !== undefined &&
          this.mapPoi.map_mods.runaway?.targets![val.key] !== undefined
        ) {
          return require("@/assets/images/map/target-purple.svg");
        } else {
          return DateHelper.getGreyMapImage(val);
        }
      } else {
        if (
          this.mapPoi.map_mods.trigger_list !== undefined &&
          this.mapPoi.map_mods.trigger_list![val.key] !== undefined
        ) {
          return require("@/assets/images/map/target-green.svg");
        } else {
          return DateHelper.getGreyMapImage(val);
        }
      }
    } else {
      return DateHelper.getGreyMapImage(val);
    }
  }

  isRunaway(val: ManhuntMapPoi): boolean {
    if (
      this.mapPoi.map_mods.active &&
      this.mapPoi.map_mods.type === "runaway"
    ) {
      if (
        this.mapPoi.map_mods.runaway !== undefined &&
        this.mapPoi.map_mods.runaway?.targets !== undefined &&
        this.mapPoi.map_mods.runaway?.targets![val.key] !== undefined
      ) {
        return true;
      }
    }
    return false;
  }

  get getValues(): any[] {
    var options = [
      {
        value: MAPMOD_TYPE.RUNAWAY,
        text: "Runaway",
      },
      {
        value: MAPMOD_TYPE.TRIGGER,
        text: "Trigger",
      },
    ];
    return options;
  }

  onValueChangedModifier(): void {
    if (this.mapPoi.map_mods.type === "trigger") {
      if (this.mapPoi.map_mods.trigger_list !== undefined) {
        this.mod_type = "trigger";
        this.errorMessage =
          "To switch mapmod type we need to unset the existing targets. This will trigger changes in the targeted POIs. Please check that others are not editing them before proceeding Continue?";
        this.$bvModal.show("modal-sm");
      } else {
        this.onValueChanged();
      }
    } else {
      if (this.mapPoi.map_mods.runaway?.targets !== undefined) {
        this.mod_type = "runaway";
        this.errorMessage =
          "To switch mapmod type we need to unset the existing targets. This will trigger changes in the targeted POIs. Please check that others are not editing them before proceeding Continue?";
        this.$bvModal.show("modal-sm");
      } else {
        this.onValueChanged();
      }
    }
  }

  deleteMapMods(): void {
    if (this.mapPoi.map_mods.type === "trigger") {
      this.mod_type = "runaway";
      delete this.mapPoi.map_mods.trigger_list;
    } else {
      this.mod_type = "trigger";
      delete this.mapPoi.map_mods.runaway?.targets;
    }
    this.onValueChangedModifier();
    this.$bvModal.hide("modal-sm");
  }

  close(): void {
    this.$bvModal.hide("modal-sm");
  }

  onValueChanged(): void {
    this.mapPoi.map_mods.type = this.mod_type;
    if (!isEqual(this.mapPoi, this.mapPoiClone)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoi);
  }

  updateTempObject(challengeData: any): void {
    this.mapPoi.map_mods = challengeData;
    if (
      this.mapPoi.map_mods.type === "trigger" &&
      isEmpty(this.mapPoi.map_mods.trigger_list)
    ) {
      this.mapPoi.map_mods.active = false;
    }
    if (
      this.mapPoi.map_mods.type === "trigger" &&
      !isEmpty(this.mapPoi.map_mods.trigger_list)
    ) {
      this.mapPoi.map_mods.active = true;
    }
    this.onValueChanged();
  }

  openLocation(event: string): void {
    try {
      if (
        this.mapPoi.map_mods.runaway?.targets !== undefined &&
        this.mapPoi.map_mods.runaway?.targets![event] !== undefined
      ) {
        delete this.mapPoi.map_mods.runaway?.targets![event];
        this.mapPoi.map_mods.active = false;
      } else {
        this.mapPoi.map_mods.active = true;
        this.mapPoi.map_mods.runaway = {
          targets: {
            [event]: true,
          },
          on_fail: this.mapPoi.map_mods.runaway!.on_fail,
          on_success: this.mapPoi.map_mods.runaway!.on_success,
          timeout_s: this.mapPoi.map_mods.runaway!.timeout_s,
        };
      }
      this.onValueChanged();
    } catch (error) {
      console.log(error);
    }
  }

  @Watch("isSavedOrDiscard")
  onisSaveOrDiscardChanged(value: boolean): void {
    if (value) {
      this.mod_type = this.mapPoi.map_mods.type;
      this.showSavePanel = false;
    }
  }
}

export default PoiMapModifiers;
